import { Component } from '@theme/component';

/**
 * Nieuwsbriefformulier in de footer (sections/newsletter-signup.liquid).
 * Controleert het e-mailadres vóór het versturen en toont dan de oranje
 * melding die er bij een fout van Shopify (`form.errors`) ook staat. Typen
 * haalt de melding weg. Versturen zelf blijft Shopify's klantformulier.
 *
 * @typedef {object} NewsletterSignupRefs
 * @property {HTMLInputElement} [input] - Het e-mailveld; ontbreekt na aanmelden.
 * @property {HTMLElement} [error] - De foutmelding.
 *
 * @extends Component<NewsletterSignupRefs>
 */
class NewsletterSignupComponent extends Component {
  static #emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/;

  connectedCallback() {
    super.connectedCallback();

    // De eigen melding vervangt de bubbel van de browser.
    const form = this.querySelector('form');
    if (form && this.refs.input) form.noValidate = true;
  }

  /**
   * @param {SubmitEvent} event
   */
  handleSubmit(event) {
    const { input } = this.refs;
    if (!input) return;

    if (NewsletterSignupComponent.#emailPattern.test(input.value.trim())) return;

    event.preventDefault();
    this.#toggleError(true);
    input.focus();
  }

  clearError() {
    if (this.refs.input?.getAttribute('aria-invalid') === 'true') this.#toggleError(false);
  }

  /**
   * @param {boolean} invalid
   */
  #toggleError(invalid) {
    const { input, error } = this.refs;
    if (!input || !error) return;

    error.hidden = !invalid;

    if (invalid) {
      input.setAttribute('aria-invalid', 'true');
      input.setAttribute('aria-describedby', error.id);
    } else {
      input.removeAttribute('aria-invalid');
      input.removeAttribute('aria-describedby');
    }
  }
}

if (!customElements.get('newsletter-signup-component')) {
  customElements.define('newsletter-signup-component', NewsletterSignupComponent);
}
